import en from "./en";
import es from "./es";
import fr from "./fr";
import de from "./de";
import pt from "./pt";
import it from "./it";

export const webLocaleResources = {
  en,
  es,
  fr,
  de,
  pt,
  it,
};

export const webSupportedLocales = Object.keys(webLocaleResources);
